module.exports = __webpack_public_path__ + "img/book-module-tab-info.51162c34.png";